import { LoadingSpinner } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect } from 'react'
import { StoreContext } from '@store/Root.store'
import { forceRedirect } from '@methods/forceRedirect'
import { API_URL } from '@constants/apiUrl'

export const SaltedgeReturnPage = observer(() => {
  const store = useContext(StoreContext)

  const location = window.location.href
  const url = new URL(location)

  useEffect(() => {
    forceRedirect(`${API_URL}/salt-edge/complete${url.search}`)
  }, [])

  return (
    <div className="page-container mobile-m-10">
      <LoadingSpinner />
    </div>
  )
})
